import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DashboardProvider } from '@providers/dashboard/dashboard'
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';
import { DetalleRondaPage} from '@pages';

@IonicPage()
@Component({
  selector: 'page-historico-retos',
  templateUrl: 'historico-retos.html',
})
export class HistoricoRetosPage {

  retos: Array<any> = [];
  retosRequest: Boolean = true;
  jugador: Jugador;
  equipo: Equipo;
  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;
  private skip: number = 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private dashboardProvider: DashboardProvider,
    private authProvider: AuthProvider
  ) {
  }

  ionViewDidLoad() {
    this.retosRequest = true;
    this.authProvider.getSession()
    .then( jugador => {
      this.jugador = jugador;
      return this.authProvider.getEquipo();
    })
    .then( equipo => {
      this.equipo = equipo;
      return this.dashboardProvider.getHistoricoRetos(this.equipo.area._id,this.jugador._id, this.skip)
    })
    .then( retos => {
      this.skip++;
      this.retos = retos;
      this.retosRequest = false;
    })
    .catch( e => {
      console.log(e);
      this.retosRequest = false;
    });
  }

  consultaRetos(infiniteScroll){
    this.retosRequest = true;
    this.dashboardProvider.getHistoricoRetos(this.equipo.area._id,this.jugador._id, this.skip)
      .then( retos => {
        this.skip++;
        if(retos.length == 0){
          infiniteScroll.enable(false);
        } else {
          this.retos = this.retos.concat(retos);
          infiniteScroll.complete();
        }
        this.retosRequest = false;
      })
      .catch( e => {
        console.log(e);
        this.retosRequest = false;
      });
  }

  detalleRonda(reto) {
    this.navCtrl.push(DetalleRondaPage, {
      areaID: this.equipo.area._id,
      jugadorID: this.jugador._id,
      oponenteID: reto.oponente._id,
      retoID: reto._id,
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/historico-retos/historico-retos.ts